<template>
    <b-row>
        <b-col class="colab-header-wrapper">
            <b-navbar toggleable="md" type="dark" variant="state-header" class="colab-header shadow">

                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

                <!-- logo  -->
                <b-navbar-brand :to="{name: 'dashboard'}" :title="$t('menu.hover.logo')">
                    <a href="#">
                        <img src="./../assets/colab-logo.svg" alt="Colab" class="logo">
                    </a>
                </b-navbar-brand>

                <b-collapse is-nav id="nav_collapse">
                    <!-- left aligned menu items -->
                    <b-navbar-nav v-if="isLoggedIn && isProjectRoute && projectId" class="text-left">
                        <b-nav-item v-if="projectId" :disabled="true" class="project-title-hint">
                            <p style="width:100%;max-width:550px" class="lead mb-0 d-inline-block text-truncate project-name">{{ projectData.name }}</p>
                        </b-nav-item>
                    </b-navbar-nav>

                    <!-- Right aligned menu items -->
                    <b-navbar-nav class="ml-auto" v-if="isLoggedIn && isProjectRoute && projectId">
<!--                        <b-nav-item exact :to="{name: 'project-home', params: { projectId }}" :title="$t('menu.hover.home')">-->
                        <b-nav-item exact :to="{name: 'project-home', params: { projectId, membership: true }}" :title="$t('menu.hover.home')">
                            <icon name="home" scale="1.25"></icon>
                            <small>{{ $t('menu.home') }}</small>
                        </b-nav-item>
                        <b-nav-item :to="{name: 'project-files', params: { projectId }}" :title="$t('menu.hover.files')">
                            <icon name="file-o" scale="1.25"></icon>
                            <small>{{ $t('menu.files') }}</small>
                        </b-nav-item>
                        <b-nav-item v-if="projectData.showTasks" :to="{name: 'project-tasks', params: { projectId }}" :title="$t('menu.hover.tasks')">
                            <icon name="tasks" scale="1.25"></icon>
                            <small>{{ $tc('general.task', 2) }}</small>
                        </b-nav-item>
                        <b-nav-item :to="{name: 'project-settings', params: { projectId }}" :title="$t('menu.hover.settings')">
                            <icon name="cogs" scale="1.25"></icon>
                            <small>{{ $t('menu.settings') }}</small>
                        </b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav :class="{'ml-0': isProjectRoute, 'ml-auto': !isProjectRoute}" v-if="isLoggedIn && userData.isAdmin">
                      <b-nav-item :to="{name: 'admin-settings'}" :title="$t('menu.hover.adminSettings')">
                        <icon name="cog" scale="1.25"></icon>
                        <small>{{ $t('menu.adminSettings') }}</small>
                      </b-nav-item>
                    </b-navbar-nav>
                    <b-navbar-nav :class="{'ml-0': isProjectRoute || (!isProjectRoute && userData.isAdmin), 'ml-auto': !isProjectRoute && !userData.isAdmin}" v-if="isLoggedIn">
                        <b-nav-item-dropdown class="user-menu">
                            <template slot="button-content" >
                                <avatar :username="userData.displayName" 
                                        :size="28" 
                                        :inline="true" 
                                        class="avatar mr-1">
                                </avatar>
                                <span class="username">{{ userData.displayName }}</span>
                                <small class="user-role" v-if="isProjectRoute && projectId && projectData.membership">
                                    <b-badge>{{(typeof projectData.membership === "string") && ['OWNER', 'GUEST', 'MEMBER'].indexOf(projectData.membership) >= 0 ?$t('project.settings.participants.roles.' + projectData.membership.toLowerCase().toUpperCase()) : projectData.membership.toUpperCase() }}</b-badge>
                                </small>
                            </template>
                            <b-dropdown-item :to="{name: 'about'}">{{ $t('general.about.menuTitle') }}</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'user-profile'}">{{ $t('profile.profile') }}</b-dropdown-item>
                            <b-dropdown-item @click="logout">{{ $t('profile.logout') }}</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
                </b-collapse>
            </b-navbar>
            <b-progress height="10px" v-if="isDownloading">
                <b-progress-bar :value="100" variant="secondary" animated>
                    <small v-text="$t('project.settings.files.downloadInProgress')"></small>
                </b-progress-bar>
            </b-progress>
        </b-col>
    </b-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import Avatar from 'vue-avatar'
import logoutService from '../shared/logout-service';

export default {
    
    components: {
        Avatar
    },

    computed: {
        ...mapState('system', ['isDownloading']),
        ...mapGetters({
            isLoggedIn: 'userData/isUserLoggedIn',
            userData: 'userData/userData',
            projectData: 'projects/projectData'
        }),

        isProjectRoute() {
            return !_.isUndefined(this.$store.state.route.params.projectId);
        },

        projectId() {
            return this.$route.params.projectId;
        }
    },

    methods: {
        logout() {
            logoutService.logout();
        }
    }
}
</script>

<style lang="scss" scoped>
    .colab-header-wrapper {
        padding-left: 0!important;
        padding-right: 0!important;
        margin-bottom: 30px;

        .project-title-hint {
            pointer-events: none!important;
        }

        .colab-header {
            box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, .05);

            .nav-item{
                list-style-type: none;
                align-items: center;
                display: flex;
                .nav-link{
                    padding: 0 0.75rem;
                    display: flex;
                    align-items: center !important;
                    flex-direction: column;
                    svg{
                        font-size: 1.5em;
                        height: 28px;
                        width: 28px;
                    }
                }
            }

            .logo {
                width: 40px !important;
                height: 40px;
            }

            .project-name {
                color: white;
                margin-right: 8px;
            }

            .navbar-collapse {
                &.collapsing{
                    .nav-item{
                        opacity: 0;
                    }
                }
                &.show {
                    .nav-item {
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        padding: 1rem;
                        opacity: 1;
                        animation: fadein 0.2s;
                    }
                }
                .dropdown-menu{
                    position: absolute !important;
                    top: 70px;
                    right: auto;
                }
            }
        }
        .user-menu{
            a{
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .username {
                font-size: 14px;
            }
            :after{
                display: none;
            }
        }

        .b-nav-dropdown {
            z-index: 9999!important;
        }

        .user-role {
            width: 100%;
            text-align: center;
            position: absolute;
            left: -1px;
            top: 19px;
            font-size: 11px;

            .badge {
                background-color: transparent;
            }
        }

        .progress {
            position: absolute;
            width: 100%;
        }
    }

    @keyframes fadein {
        from { opacity: 0; }
        to   { opacity: 1; }
    }
</style>
